import * as actionTypes from './actionTypes';
import * as actions from './index';
import * as Metadata from 'Flow2/containers/Masterdata/Masterdata';

// Clip

const updateMetadataClipStart = () => {
    return {
        type: actionTypes.UPDATE_METADATA_CLIP_START
    };
};


const updateMetadataClipSuccess = () => {
    return {
        type: actionTypes.UPDATE_METADATA_CLIP_SUCCESS
    };
};


const updateMetadataClipFail = (error) => {
    return {
        type: actionTypes.UPDATE_METADATA_CLIP_FAIL,
        error: error
    };
};

// Project

const updateMetadataProjectStart = () => {
    return {
        type: actionTypes.UPDATE_METADATA_PROJECT_START
    };
};

const updateMetadataProjectSuccess = () => {
    return {
        type: actionTypes.UPDATE_METADATA_PROJECT_SUCCESS
    };
};

const updateMetadataProjectFail = (error) => {
    return {
        type: actionTypes.UPDATE_METADATA_PROJECT_FAIL,
        error: error
    };
};

const addMemberProjectStart = () => {
    return {
        type: actionTypes.ADD_MEMBER_PROJECT_START
    };
};

const addMemberProjectSuccess = (project) => {
    return {
        type: actionTypes.ADD_MEMBER_PROJECT_SUCCESS,
        // type: actionTypes.PROJECT_UPDATE_RECEIVED,
        project: project
    };
};

const addMemberProjectFail = (error) => {
    return {
        type: actionTypes.ADD_MEMBER_PROJECT_FAIL,
        error: error
    };
};

// Distribution

const updateMetadataDistributionStart = () => {
    return {
        type: actionTypes.UPDATE_METADATA_DISTRIBUTION_START
    };
};

const updateMetadataDistributionSuccess = () => {
    return {
        type: actionTypes.UPDATE_METADATA_DISTRIBUTION_SUCCESS
    };
};

const updateMetadataDistributionFail = (error) => {
    return {
        type: actionTypes.UPDATE_METADATA_DISTRIBUTION_FAIL,
        error: error
    };
};

// Room

const updateMetadataRoomStart = () => {
    return {
        type: actionTypes.UPDATE_METADATA_ROOM_START
    };
};

const updateMetadataRoomSuccess = () => {
    return {
        type: actionTypes.UPDATE_METADATA_ROOM_SUCCESS
    };
};

const updateMetadataRoomFail = (error) => {
    return {
        type: actionTypes.UPDATE_METADATA_ROOM_FAIL,
        error: error
    };
};

// Config

const loadMetadataConfigStart = () => {
    return {
        type: actionTypes.LOAD_METADATA_CONFIG_START
    };
};

const loadMetadataConfigSuccess = (config) => {
    return {
        type: actionTypes.LOAD_METADATA_CONFIG_SUCCESS,
        config: config
    };
};

const loadMetadataConfigFail = (error) => {
    return {
        type: actionTypes.LOAD_METADATA_CONFIG_FAIL,
        error: error
    };
};

export const loadMetadataConfig = (local = true) => {
    return dispatch => {
        if (local) {
            console.log("LOAD LOCAL METADATA CONFIG");
            dispatch(loadMetadataConfigStart());
            import(`${process.env.REACT_APP_APPID}/config/MetadataConfig`).then((module) => {
                dispatch(loadMetadataConfigSuccess(module));
            }).catch((res) => {
                dispatch(loadMetadataConfigFail(res.message));
            });
        } else {
            console.log("LOAD EXTERNAL METADATA CONFIG");

            // TODO
            // remove and implement correct process to load config from server

            dispatch(loadMetadataConfigStart());
            import(`${process.env.REACT_APP_APPID}/config/MetadataConfig`).then((module) => {
                dispatch(loadMetadataConfigSuccess(module));
            }).catch((res) => {
                dispatch(loadMetadataConfigFail(res.message));
            });
        }
    }
};

export const loadSoapApiDef = () => {
    return dispatch => {
        dispatch({type: actionTypes.LOAD_SOAP_API_DEF_START });
        window.flow.getSoapapidef().then((apiDef) => {
            dispatch({type: actionTypes.LOAD_SOAP_API_DEF_SUCCESS, apiDef: apiDef });
        }).catch((res) => {
            console.log(res);
            dispatch({type: actionTypes.LOAD_SOAP_API_DEF_FAIL });
        });
    }
}

export const saveMetadataConfig = (user, config, type) => {
    return dispatch => {
        let field = "";
        
        switch(type) {
            case Metadata.OBJECT_TYPE_PROJECT:
                field = "metadata_project";
                break;
            case Metadata.OBJECT_TYPE_CLIP:
            default:
                field = "metadata_clip";
                break;
        }
        
        dispatch( { type: actionTypes.SAVE_METADATA_CONFIG_START } );
        window.flow.grantingEditUser(user.groupid, user.id, [
            { 'name': field, 'value': config }
        ], true).then((res) => {
            console.log("saveMetadataConfigSuccess", res);
            dispatch( { type: actionTypes.SAVE_METADATA_CONFIG_SUCCESS } );
            dispatch( { type: actionTypes.UPDATE_METADATA_CONFIG, config: JSON.parse(config), field: type } );
        }).catch(res => {
            dispatch( { type: actionTypes.SAVE_METADATA_CONFIG_FAIL } );
            console.log("saveMetadataConfigFail");
        });
    }
}

export const updateMetadata4Upload = (type, id, metadata) => {
    return dispatch => {
        switch (type) {
            case Metadata.OBJECT_TYPE_CLIP:
                window.flow.editClip(id, metadata).then((clip) => {
                    if (clip && clip.mediafiles && clip.mediafiles.elements) {
                        dispatch({ type: actionTypes.UPLOAD_UPDATE_METADATA, payload: { mediafiles: clip.mediafiles.elements } });
                        //console.log("LAMTEST clip.mediafiles.elements", clip.mediafiles.elements);
                    }
                }).catch((res) => {
                    console.log(res);
                });
                break;
            default:
                break;
        }
    }
};


export const updateMetadata = (type, id, metadata, reload = true) => {
    return dispatch => {
        switch (type) {
            case Metadata.OBJECT_TYPE_PROJECT:
                console.log("UPDATE PROJECT");
                dispatch(updateMetadataProjectStart());
                dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
                window.flow.editProject(id, metadata).then((project) => {
                    console.log("SUCCESS");
                    console.log(project);
                    dispatch(updateMetadataProjectSuccess());
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                    // reload projects and  project tree
                    if (reload) {
                        dispatch(actions.getProjectTree());
                        dispatch(actions.getProjects());
                        dispatch(actions.getDeletedProjects());
                    }
                    //dispatch({ type: actionTypes.PROJECT_UPDATE_RECEIVED, project: project });
                }).catch((res) => {
                    console.log(res);
                    dispatch(updateMetadataProjectFail(res.message));
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                });
                break;
            case Metadata.OBJECT_TYPE_DISTRIBUTION:
                console.log("UPDATE DISTRIBUTION");
                dispatch(updateMetadataDistributionStart());
                dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
                window.flow.editDistproject(id, metadata).then((res) => {
                    console.log("SUCCESS");
                    dispatch(updateMetadataDistributionSuccess());
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                    if (reload) {
                        dispatch(actions.getDistributionByDist());
                        dispatch(actions.getDistributionTree());
                    }
                    //dispatch({ type: actionTypes.PROJECT_UPDATE_RECEIVED, project: project});
                }).catch((res) => {
                    console.log(res);
                    dispatch(updateMetadataDistributionFail(res.message));
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                });
                break;
            case Metadata.OBJECT_TYPE_ROOM:
                console.log("UPDATE ROOM");
                dispatch(updateMetadataRoomStart());
                dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
                window.flow.editShowroom(id, metadata).then((room) => {
                    console.log("SUCCESS");
                    console.log(room);
                    dispatch(updateMetadataRoomSuccess());
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                    if (reload) {
                        dispatch(actions.getRooms());
                        dispatch(actions.getDeletedRooms());
                    }
                    //dispatch({ type: actionTypes.ROOM_UPDATE_RECEIVED, room: room });
                }).catch((res) => {
                    console.log(res);
                    dispatch(updateMetadataRoomFail(res.message));
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                });
                break;
            case Metadata.OBJECT_TYPE_CLIP:
                console.log("UPDATE CLIP");
                dispatch(updateMetadataClipStart());
                dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
                window.flow.editClip(id, metadata).then((clip) => {
                    console.log(metadata);
                    console.log("SUCCESS");
                    dispatch(updateMetadataClipSuccess());
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                    if (reload) {
                        console.log("getClipById(id)");
                        dispatch(actions.getClipById(id));
                    }
                    //dispatch({ type: actionTypes.CLIP_UPDATE_RECEIVED, clip: clip });
                }).catch((res) => {
                    console.log(res);
                    dispatch(updateMetadataClipFail(res.message));
                    dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
                });
                break;
            default:
                break;
        }

    }
};

export const addMemberToProject = (id, member) => {
    return ((dispatch) => {
        console.log("ADD MEMBER TO PROJECT");
        dispatch(addMemberProjectStart());
        dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
        window.flow.projectAddMember(id, member).then((project) => {
            console.log("SUCCESS");
            dispatch(addMemberProjectSuccess(project));
            dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
            //dispatch({ type: actionTypes.PROJECT_UPDATE_RECEIVED, project: project});
        }).catch((res) => {
            console.log(res);
            dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
            dispatch(addMemberProjectFail(res.message));
        });
    });
}


export const delMemberFromProject = (projectId, memberId) => {
    return (dispatch => {
        // dispatch(delMemberFromProjectStart());
        console.log('REMOVE MEMBER FROM PROJECT');
        dispatch({ type: actionTypes.METADATA_LOADING, loading: true });
        window.flow.projectDelMember(projectId, memberId).then(project => {
            console.log('SUCCESS');
            dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
            // dispatch(delMemberFromProjectSuccess());
        }).catch(res => {
            console.log(res);
            // dispatch(delMemberFromProjectFail(res.message));
            dispatch({ type: actionTypes.METADATA_LOADING, loading: false });
        })
    })
}
